/**
 * Monitor Messaging System Results
 * Monitors Firestore for message creation and queue processing after test mention
 *
 * USAGE: await window.monitorMessagingSystem()
 */

import { collection, query, where, orderBy, limit, getDocs } from "firebase/firestore";
import { db } from "../firebase.js";

async function monitorMessagingSystem() {
  console.log("🔍 Monitoring messaging system results...\n");

  try {
    const schoolId = "hktnikYSv6l6vGPbjMmG";
    
    console.log("📋 Monitoring for School:", schoolId);
    console.log("⏰ Checking for recent activity (last 10 minutes)\n");
    
    // Check recent mentions
    console.log("📄 Recent Mentions:");
    const mentionsRef = collection(db, "schools", schoolId, "mentions");
    const mentionsQuery = query(
      mentionsRef,
      where("timestamp", ">=", new Date(Date.now() - 10 * 60 * 1000).toISOString()),
      orderBy("timestamp", "desc"),
      limit(5)
    );
    const mentionsSnapshot = await getDocs(mentionsQuery);
    
    if (mentionsSnapshot.empty) {
      console.log("   ❌ No recent mentions found");
    } else {
      mentionsSnapshot.forEach(doc => {
        const data = doc.data();
        console.log(`   ✅ ${data.timestamp}: ${data.studentName} - ${data.offense}`);
        console.log(`      ID: ${doc.id}, Status: ${data.status}`);
      });
    }
    
    console.log("\n📨 Messages Created:");
    // Check recent messages
    const messagesRef = collection(db, "schools", schoolId, "messages");
    const messagesQuery = query(
      messagesRef,
      where("createdAt", ">=", new Date(Date.now() - 10 * 60 * 1000)),
      orderBy("createdAt", "desc"),
      limit(5)
    );
    const messagesSnapshot = await getDocs(messagesQuery);
    
    if (messagesSnapshot.empty) {
      console.log("   ❌ No recent messages found");
    } else {
      messagesSnapshot.forEach(doc => {
        const data = doc.data();
        console.log(`   ✅ ${data.createdAt?.toDate?.() || "N/A"}: Student ${data.studentId}`);
        console.log(`      Type: ${data.messageType}, Status: ${data.status}`);
        console.log(`      Recipient: ${data.recipientName || "N/A"}`);
      });
    }
    
    console.log("\n⚙️ Queue Items:");
    // Check recent queue items
    const queueRef = collection(db, "schools", schoolId, "queue");
    const queueQuery = query(
      queueRef,
      where("createdAt", ">=", new Date(Date.now() - 10 * 60 * 1000)),
      orderBy("createdAt", "desc"),
      limit(5)
    );
    const queueSnapshot = await getDocs(queueQuery);
    
    if (queueSnapshot.empty) {
      console.log("   ❌ No recent queue items found");
    } else {
      queueSnapshot.forEach(doc => {
        const data = doc.data();
        console.log(`   ✅ ${data.createdAt?.toDate?.() || "N/A"}: ${data.studentName}`);
        console.log(`      Type: ${data.type}, Status: ${data.status}`);
        console.log(`      Scheduled: ${data.scheduledFor?.toDate?.() || "N/A"}`);
      });
    }
    
    console.log("\n📊 Summary:");
    console.log(`   Mentions found: ${mentionsSnapshot.size}`);
    console.log(`   Messages created: ${messagesSnapshot.size}`);
    console.log(`   Queue items: ${queueSnapshot.size}`);
    
    if (mentionsSnapshot.size > 0 && messagesSnapshot.size === 0) {
      console.log("\n⚠️  WARNING: Mentions found but no messages created");
      console.log("   - Check mention trigger Cloud Function logs");
      console.log("   - Verify message templates are seeded");
    }
    
    if (messagesSnapshot.size > 0 && queueSnapshot.size === 0) {
      console.log("\n⚠️  WARNING: Messages created but no queue items");
      console.log("   - Check queue processor Cloud Function logs");
      console.log("   - Verify scheduled function is running (every 2 minutes)");
    }
    
    if (messagesSnapshot.size > 0 && queueSnapshot.size > 0) {
      console.log("\n✅ SUCCESS: Messaging system appears to be working!");
      console.log("   - Mentions triggered message creation");
      console.log("   - Queue processor found and processed messages");
    }
    
    return {
      mentions: mentionsSnapshot.size,
      messages: messagesSnapshot.size,
      queueItems: queueSnapshot.size,
      success: mentionsSnapshot.size > 0 && messagesSnapshot.size > 0 && queueSnapshot.size > 0
    };
    
  } catch (error) {
    console.error("❌ Error monitoring messaging system:", error);
    throw error;
  }
}

export { monitorMessagingSystem };